import { useCallback } from "react";
import classNames from "classnames";
import { useNavigate } from "react-router";

import Highlight from "components/text/Highlight";
import Link from "ds/components/Link";

import styles from "./styles.module.css";
import { ListBoxItemLink } from "./types";

const ListBoxLink = (props: ListBoxItemLink) => {
  const navigate = useNavigate();
  const {
    headerLink,
    renderAsCode,
    routerLink,
    text,
    url,
    state,
    highlightMatches,
    target = "_blank",
  } = props;

  const linkClass = classNames(styles.listBoxLink, {
    [styles.listBoxInfo]: !headerLink,
  });
  const textClass = classNames({ [styles.listBoxCode]: renderAsCode });

  const handleNavigate = useCallback(() => {
    if (routerLink && state) {
      navigate(url as string, { state });
    }
  }, [routerLink, state, url, navigate]);

  if (routerLink) {
    return (
      <Link
        variant="secondary"
        onPress={state ? handleNavigate : undefined}
        className={linkClass}
        href={url}
        inheritFont
      >
        <span className={textClass}>
          <Highlight text={text} matches={highlightMatches} />
        </span>
      </Link>
    );
  }

  return (
    <Link
      className={linkClass}
      href={url}
      rel="noopener noreferrer"
      target={target}
      inheritFont={headerLink}
      variant={headerLink ? "secondary" : "primary"}
    >
      {text}
    </Link>
  );
};

export default ListBoxLink;
